export function ReportFormIntro() {
    return (
        <div>
            <div className="mb-6">親愛的用戶：</div>
            <div>
                若您確定要檢舉此內容，請選擇以下欄位中的原因，並填寫詳盡的檢舉描述。填寫完成後，您即可提交檢舉。
            </div>
        </div>
    )
}
